import { getAppUrl } from "@/helper/url";
import { propertiesCitiesCountSchema } from "@/schemas/properties";

import type { Uf } from "@/types";

const url = `${getAppUrl()}/api/properties`;

export const fetchPropertiesUfCities = async ({ uf }: Uf) => {
  try {
    const response = await fetch(`${url}/${uf}/cities`);

    if (!response.ok) {
      throw new Error("Erro ao buscar cidades por UF");
    }

    const data = await response.json();

    return propertiesCitiesCountSchema.parse(data);
  } catch (error) {
    console.error("Erro ao buscar cidades por UF:", error);
    throw new Error(
      error instanceof Error ? error.message : "Erro ao buscar cidades por UF"
    );
  }
};
